import { ModalContentContainer } from 'common/components/wizard/ModalContentContainer'
import { ModalHeader } from '../../components/ModalHeader'
import { ModalController } from 'common/components/wizard/ModalController'
import { Wizard } from 'common/components/wizard/Wizard'
import { WizardStep } from 'common/components/wizard/WizardStep'
import React, { useEffect, useState } from 'react'
import { Step1BookingCategory } from './Step1BookingCategory'
import {
  Step2BookingDetails,
} from './Step2BookingDetails'
import { Step3BookingCalendar } from './Step3BookingCalendar'
import { MemberProfileExtendedType } from 'common/types/MemberProfile'
import { BookingCategory, BookingCategoryLabels, BookingDetailsFields } from 'common/types/MemberBooking'
import { useGetOccupations } from 'common/hooks/useGetOccupations'
import { Step4ConfirmationNotice } from '../MemberBookingWizard/Step4ConfirmationNotice'

interface MemberBookingWizardProps {
  profile: MemberProfileExtendedType
  isOpen: boolean
  handleClose?: () => void
}

export const MemberBookingWizard = ({
  profile,
  isOpen,
  handleClose,
}: MemberBookingWizardProps) => {
  const [bookingCategory, setBookingCategory] = useState<BookingCategory | null>(null)
  const [bookingDetails, setBookingDetails] =
    useState<BookingDetailsFields | null>(null)
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const [bookingDateTime, setBookingDateTime] = useState<Date | null>(null)
  const { occupations, loadOccupations } = useGetOccupations()

  useEffect(() => {
    loadOccupations()
  }, [])

  const NUMBER_OF_STEPS = 4

  useEffect(() => {
    if (!isOpen) {
      setBookingCategory(null)
      setBookingDetails(null)
      setSelectedFile(null)
      setBookingDateTime(null)
    }
  }, [isOpen])

  const headerText = `Make a booking` + (bookingCategory ? ` - ${BookingCategoryLabels[bookingCategory]}` : '')

  const handleStep2Submit = (values: BookingDetailsFields) => {
    return new Promise<void>((resolve) => {
      setBookingDetails(values)
      setSelectedFile(values.selectedFile || null)
      resolve()
    })
  }

  return (
    <Wizard totalSteps={NUMBER_OF_STEPS} isWizardOpen={isOpen}>
      <ModalController
        isModalOpen={isOpen}
        onClose={handleClose}
        widths='md:w-[810px]'
      >
        <ModalHeader headerText={headerText} onClose={handleClose} />
        <ModalContentContainer>
          <WizardStep step={1}>
            <Step1BookingCategory
              bookingCategory={bookingCategory}
              setBookingCategory={setBookingCategory}
            />
          </WizardStep>
          <WizardStep step={2}>
            <Step2BookingDetails
              bookingCategory={bookingCategory}
              handleStep2Submit={handleStep2Submit}
              initialValues={bookingDetails}
              occupations={occupations}
              selectedFile={selectedFile}
              setSelectedFile={setSelectedFile}
            />
          </WizardStep>
          <WizardStep step={3}>
            <Step3BookingCalendar
              bookingCategory={bookingCategory}
              profile={profile}
              bookingDateTime={bookingDateTime}
              setBookingDateTime={setBookingDateTime}
              bookingDetails={bookingDetails}
              selectedFile={selectedFile}
            />
          </WizardStep>
          <WizardStep step={4}>
            <Step4ConfirmationNotice lawyerDisplayName={profile.displayName} bookingDateTime={bookingDateTime} />
          </WizardStep>
        </ModalContentContainer>
      </ModalController>
    </Wizard>
  )
}
